<template>
	<div>
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="设置" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<van-cell class="phoneNum" title="手机号" is-link :value="mobile" to="/MobilePhoneNumber" />
		<van-cell class="changePassword" title="修改密码" is-link to="/mobileForgetPassword" />
		<van-cell class="edition" title="版本信息" value="V1.7" />
		<div style="display: flex; justify-content: center">
			<van-button @click="logout" plain type="danger">退出登录</van-button>
		</div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
	data() {
		return {
			mobile: "",
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
		};
	},
	methods: {
		/**
		 * 获取个人信息
		 */
		judgeLogin() {
			if (localStorage.getItem("loginUrl")) {
				this.getUserInfor();
			} else {
				Toast("请先登录");
				this.$router.push({ path: "/mobileLogin" });
			}
		},
		getUserInfor() {
			this.$api.get("/user/getUserDetail", null, (res) => {
				if (status == 0) {
					this.mobile = res.data.mobile;
				}
			});
		},
		onClickLeft() {
			this.$router.go(-1);
		},
		/* 退出 */
		logout() {
			Dialog.confirm({
				title: "退出登录",
				message: "确认要退出吗？",
			})
				.then(() => {
					this.logoutFun();
				})
				.catch(() => {});
		},
		logoutFun() {
			localStorage.clear()
			this.$sessionStore.clearSession();
			this.$api.post("/user/logoutV", null, (res) => {
				this.$router.push({ path: "/mobileHome" });
			});
		},
	},
	mounted() {
		this.judgeLogin();
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>

<style scoped>
.body {
	background-color: #f2f2f2;
}
.van-nav-bar__content {
	font-weight: bold;
}
.van-button {
	width: 9.146667rem;
	height: 1.28rem;
	margin-top: 0.426667rem;
    border-radius: 0.106667rem;
}
.van-cell {
	width: 9.146667rem;
	margin: 0 auto;
	height: 1.28rem;
}
.phoneNum {
	margin-top: 0.426667rem;
	border-radius: 0.106667rem 0.106667rem 0 0;
}
.changePassword {
	margin-bottom: 0.426667rem;
	border-radius: 0 0 0.106667rem 0.106667rem;
}
.edition {
	border-radius: 0.106667rem;
}
.van-button {
	border: none;
	font-weight: 400;
	font-size: 0.373333rem;
}
</style>


// WEBPACK FOOTER //
// MobileSet.vue?5ccafb78